import { SlideDotActiveIcon } from "../../../../assets/icons.constants";

const SlideDotActiveTodayMenuIcon = (props) => {
  const { color } = props;
  return <SlideDotActiveIcon color={color ?? "#DB4D29"} />;
};

export default SlideDotActiveTodayMenuIcon;
